import { styled } from 'ui/styles'

export const HBox = styled.div<{ height: number }>`
  height: ${({ height }) => height}px;
`
